export default __webpack_public_path__ + "static/media/placeholder_portrait_gray.0acb9e03.svg";